const formatPhone = {
    install(Vue) {
        Vue.filter('formatPhone', (value) => {
            if (!value) {
                return value
            }

            if (typeof value == 'number') {
                value = value.toString()
            }

            if (value && value.length < 12) {
                const ddd = value.substring(0,2)
                const prefix = value.length == 11 ? value.substring(2,7) : value.substring(2,6)
                const suffix = value.length == 11 ? value.substring(7) : value.substring(6)        
                return `(${ddd}) ${prefix}-${suffix}`
            } else if (value.startsWith("55")  || value.startsWith("+55")) {
                const number = value.substring(value.startsWith("+55") ? 3 : 2)
                const ddd = number.substring(0,2)
                const prefix = number.length == 11 ? number.substring(2,7) : number.substring(2,6)
                const suffix = number.length == 11 ? number.substring(7) : number.substring(6)        
                return `(${ddd}) ${prefix}-${suffix}`
            } else {
                return value
            }            
        });
    },
};

export default formatPhone